export const BUTTON_SIZES_MAP = {
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
  XL: 'xl',
  '2XL': '2xl',
} as const;

export type ButtonSize = (typeof BUTTON_SIZES_MAP)[keyof typeof BUTTON_SIZES_MAP];

/** Type guard for ButtonSize - to make sure we aren't modifying legacy Button usage */
export const isValidButtonSize = (size: unknown): size is ButtonSize => {
  return Object.values(BUTTON_SIZES_MAP).includes(size as ButtonSize);
};

export const BUTTON_HIERARCHY_MAP = {
  PRIMARY: 'Primary',
  PRIMARY_DESTRUCTIVE: 'Primary destructive',
  SECONDARY_GRAY: 'Secondary gray',
  TERTIARY_COLOR: 'Tertiary color',
  SECONDARY_COLOR: 'Secondary color',
} as const;

export type ButtonHierarchy = (typeof BUTTON_HIERARCHY_MAP)[keyof typeof BUTTON_HIERARCHY_MAP];

export const BUTTON_ICON_MAP = {
  DEFAULT: 'Default',
  LEADING: 'Leading',
  ONLY: 'Only',
} as const;

export type ButtonIcon = (typeof BUTTON_ICON_MAP)[keyof typeof BUTTON_ICON_MAP];
